module.exports = __webpack_public_path__ + "static/media/card-icon-02.94f5e000.svg";